import {
  ALL_METRICS_SUCCESS,
  ALL_METRICS_REQUEST,
  ALL_METRICS_FAILURE,
  SET_METRICS_FILTER,
  CLEAR_METRICS_FILTER,
} from '../actions/metrics'

export function allMetrics(
  state = {
    isFetching: false,
    results: {},
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case ALL_METRICS_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case ALL_METRICS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response,
      }
    case ALL_METRICS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    default:
      return state
  }
}

export const metricsFilter = (state = { filter: {}, content: null }, action) => {
  switch (action.type) {
    case SET_METRICS_FILTER:
      return { ...state, filter: { ...action.content } }
    case CLEAR_METRICS_FILTER:
      return { ...state, filter: {} }
    default:
      return state
  }
}
